import React, { useState, useEffect } from "react"
import styled from "styled-components"
import breakpoints from "../../../styles/breakpoints"
import fonts from "../../../styles/fonts"
import { withTranslation } from "gatsby-plugin-react-i18next"
import colors from "../../../styles/colors"
import OnClickButtonLightGreen from "../../Core/Buttons/OnClickButtonLightGreen"
import CloseIcon from "../../../resources/img/ui/plp/icon-close.svg"
import WeddingFilter from "../WeddingFilter"

const DesktopFilterContainer = styled.div`
  display: none;
  margin: 0 auto 33px;
  padding-right: 46px;
  position:relative;
  @media (min-width: ${breakpoints.lg}) {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`

const FilterContainer = styled.div`
  position: relative;
  flex: 1;
  padding-bottom: 21px;
  border-bottom: 1px solid #cacaca;

  @media (min-width: ${breakpoints.lg}) {
    display: flex;
    justify-content: flex-end;
  }
`

const FilterOverlayContainer = styled.div`
  min-width: 100%;
  position: relative;
`

const Filter = styled.div`
  ${fonts.openSans};
  width: 50%;
  max-width: 110px;
  padding: 18px 0;
  display: flex;
  justify-content: space-between;
  position: relative;
  cursor: pointer;

  &:first-of-type {
    margin-right: 26px;
    max-width: 80px;
  }
  @media (min-width: ${breakpoints.xl}) {
    &:first-of-type {
      margin-right: 49px;
    }
  }
`

const FilterTitle = styled.div`
  font-size: 14px;
  b {
    text-transform: uppercase;
    font-weight: 600;
  }
`

const FilterToggle = styled.div`
  font-weight: 600;
  padding-left: 4px;
`

const SortOptions = styled.div`
  position: absolute;
  width: 100%;
  padding: 30px 18px;
  top: 100%;
  border: 1px solid #cacaca;
  background: ${colors.white};
  z-index: 10;
  min-width: max-content;
  right: 0;
`

const SortOption = styled.li`
  margin-bottom: 10px;
  text-decoration: ${(props) => (props.selected ? "underline" : "none")};
  &:last-of-type {
    margin-bottom: 0;
  }
`

const FilterOptionsContainer = styled.div`
  position: absolute;
  top: calc(100% - 1px);
  border: 1px solid #cacaca;
  background: ${colors.white};
  width: 100%;
  z-index: 99;
`

const FilterOptions = styled.div`
  position: relative;
  padding: 40px 39px 0 76px;
  display: flex;
  flex-wrap: wrap;
`

const FilterOption = styled.div`
  ${fonts.openSans};
  margin-right: 101px;
  font-size: 14px;

  ul {
    li {
      color: ${colors.textGrey};
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }
`

const Checkbox = styled.div`
  width: 13px;
  height: 13px;
  border: 1px solid ${colors.black};
  background: ${(props) => (props.selected ? colors.lightGreen : colors.beige)};
  margin-right: 10px;
`

const FilterOptionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 12px;
`

const ClearButton = styled.button`
  ${fonts.openSans};
  color: ${colors.mediumTextGrey};
  font-size: 14px;
  text-decoration: underline;
  text-transform: uppercase;
  cursor: pointer;
  background: transparent;
  border: none;
  text-align: center;
  margin-right: 36px;
`

const ButtonsContainer = styled.div`
  min-width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 20px 0 40px;

  div,
  button {
    ${fonts.openSans};
    font-weight: 600;
  }
`

const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 20px;
  right: 20px;
`

const DesktopFilters = (props) => {
  const {
    t,
    filterOptions,
    sort,
    colours,
    types,
    price,
    styles,
    applyFilter,
    setSort,
    handleColour,
    handlePrice,
    handleTypeFilter,
    handleStyle,
    clearFilter,
    wedding,
  } = props

  const [open, setOpen] = useState()

  const handleOpen = (value) => {
    if (open === value) {
      setOpen(null)
    } else {
      setOpen(value)
    }
  }

  useEffect(() => {
    if (window.innerWidth >= parseFloat(breakpoints.lg)) {
      applyFilter()
    }
  }, [sort])

  const sortFilter = filterOptions.find((filter) => filter?.value === "sort")
  const filters = filterOptions.filter((filter) => filter?.value !== "sort")
  const formattedSortValue =
    sort.title.length > 20 ? sort.title.slice(0, 17) + "..." : sort.title

  const handleSelect = (option, filterValue) => {
    if (filterValue === "colour") {
      return handleColour(option)
    }
    if (filterValue === "price") {
      return handlePrice(option)
    }

    if (filterValue === "type") {
      return handleTypeFilter(option)
    }

    if (filterValue === "style") {
      return handleStyle(option)
    }
  }

  const checkSelected = (option, filterValue) => {
    if (filterValue === "colour") {
      const selectedColours = [...colours]
      const selectedColourValues =
        selectedColours.length > 0
          ? selectedColours.map((colour) => colour?.value)
          : []
      return selectedColourValues.includes(option.value)
    }
    if (filterValue === "price") {
      return price && price.value === option.value
    }
    if (filterValue === "type") {
      const selectedTypes = [...types]
      const selectedTypeValues =
        selectedTypes.length > 0 ? selectedTypes.map((type) => type?.value) : []
      return selectedTypeValues.includes(option.value)
    }
    if (filterValue === "style") {
      const selectedStyles = [...styles]
      const selectedStyleValues =
        selectedStyles.length > 0 ? selectedStyles.map((style) => style?.value) : []
      return selectedStyleValues.includes(option.value)
    }
  }

  const apply = () => {
    applyFilter()
    setOpen(null)
  }

  return (
    <DesktopFilterContainer>
      {wedding && <WeddingFilter />}
      <FilterContainer>
        <Filter onClick={() => handleOpen("filter")}>
          <FilterTitle>
            <b>{t("plp.filter.filters")}</b>
          </FilterTitle>
          <FilterToggle>{open === "filter" ? "–" : "+"}</FilterToggle>
        </Filter>
        <Filter onClick={() => handleOpen("sort")}>
          <FilterTitle>
            <b>{sortFilter.title}:</b> {formattedSortValue}
          </FilterTitle>
          <FilterToggle>{open === "sort" ? "–" : "+"}</FilterToggle>
          {open === "sort" && (
            <SortOptions>
              <ul>
                {sortFilter.options.map((option) => {
                  return (
                    <SortOption
                      key={option.value}
                      onClick={() => setSort(option)}
                      selected={sort && sort.value === option.value}
                    >
                      {option.title}
                    </SortOption>
                  )
                })}
              </ul>
            </SortOptions>
          )}
        </Filter>
      </FilterContainer>
      <FilterOverlayContainer>
        {open === "filter" && (
          <FilterOptionsContainer>
            <FilterOptions>
              <CloseButton onClick={() => setOpen(null)}>
                <img src={CloseIcon} alt="close" />
              </CloseButton>
              {filters.map((filter) => {
                if (!filter) return null;
                return (
                  <FilterOption key={filter.value}>
                    <FilterOptionTitle>
                      {t("plp.filter.by")} {filter.title}
                    </FilterOptionTitle>
                    <ul>
                      {filter.options.map((option) => {
                        if (!option) return null
                        return (
                          <li
                            key={option.value}
                            onClick={() => handleSelect(option, filter.value)}
                          >
                            <Checkbox
                              selected={checkSelected(option, filter.value)}
                            />
                            {option.title}
                          </li>
                        )
                      })}
                    </ul>
                  </FilterOption>
                )
              })}
              <ButtonsContainer>
                <ClearButton onClick={() => clearFilter("desktop")}>
                  {t("plp.filter.sort_clear_all")}
                </ClearButton>
                <OnClickButtonLightGreen onClick={() => apply()}>
                  {t("plp.filter.sort_apply")}
                </OnClickButtonLightGreen>
              </ButtonsContainer>
            </FilterOptions>
          </FilterOptionsContainer>
        )}
      </FilterOverlayContainer>
    </DesktopFilterContainer>
  )
}

export default withTranslation()(DesktopFilters)
